<ul nz-menu class="!p-1.5">
    <li nz-menu-item [routerLink]="['/my-profile']">
        <div class="flex-start-center gap-x-2 h-8">
            <span class="text-sm">My Profile</span>
        </div>
    </li>

    <li *ngIf="socialMediaVisible" nz-menu-item [routerLink]="['/my-profile/edit']">
        <div class="flex-start-center gap-x-2 h-8">
            <span class="text-sm">My Social Media</span>

            <div class="bonus-watchlist-points">
                <img src="/assets/imgs/icon/sun-v2.png" class="w-[14px]" alt="" />
                <span>Earn Points</span>
            </div>
        </div>
    </li>

    <div class="bg-line h-px w-full my-1"></div>

    <li nz-menu-item [routerLink]="['/meme-dashboard/my-watchlist']">
        <div class="flex-start-center gap-x-2 h-8">
            <span class="text-sm">My Watchlist</span>
        </div>
    </li>

    <li nz-menu-item [routerLink]="['/meme-dashboard/watchlist-marketplace']" [queryParams]="{filter_subscribed:'1'}">
        <div class="flex-start-center gap-x-2 h-8">
            <span class="text-sm">My Subscribed Watchlists({{subscribedWatchlistCount}})</span>
        </div>
    </li>

    <div class="bg-line h-px w-full my-1"></div>

    <li nz-menu-item (click)="showSettingsModal()">
        <div class="flex-start-center gap-x-2 h-8">
            <span class="text-sm">Settings</span>
        </div>
    </li>

    <li nz-menu-item (click)="toggleWalletConnection()">
        <div class="flex-start-center h-8">
            <span class="text-sm">
                Logout
                <span *ngIf="walletStatusService.disconnecting" class="text-white text-sm ml-1" nz-icon nzType="loading" nzTheme="outline"></span>
            </span>
        </div>
    </li>
</ul>
